// features/admin/RegisterUserForm.tsx
import { useState, FormEvent } from 'react';
import { registerUser } from '../auth/api';
import { toast } from 'react-hot-toast';

type Role = "admin" | "superadmin" | "loading_manager";

interface FormState {
  name: string;
  email: string;
  password: string;
  role: Role;
}

export default function RegisterUserForm() {
  const [form, setForm] = useState<FormState>({
    name: '',
    email: '',
    password: '',
    role: 'admin',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value as string });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const user = await registerUser(form);
    if (user) {
      toast.success('User registered successfully');
      setForm({ name: '', email: '', password: '', role: 'admin' });
    } else {
      toast.error('Failed to register user');
    }
  };


return (
  <form
    onSubmit={handleSubmit}
    className="space-y-4 max-w-lg mx-auto bg-white dark:bg-slate-900 p-6 rounded-xl shadow text-dark dark:text-light"
  >
    <h2 className="text-2xl font-semibold mb-4 text-primary dark:text-primary-light">
      👤 Register New User
    </h2>

    <input
      type="text"
      name="name"
      placeholder="Full Name"
      required
      value={form.name}
      onChange={handleChange}
      className="w-full p-3 rounded-lg border border-slate-300 dark:border-slate-700 bg-light dark:bg-slate-800 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
    />
    <input
      type="email"
      name="email"
      placeholder="Email"
      required
      value={form.email}
      onChange={handleChange}
      className="w-full p-3 rounded-lg border border-slate-300 dark:border-slate-700 bg-light dark:bg-slate-800 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
    />
    <input
      type="password"
      name="password"
      placeholder="Password"
      required
      value={form.password}
      onChange={handleChange}
      className="w-full p-3 rounded-lg border border-slate-300 dark:border-slate-700 bg-light dark:bg-slate-800 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
    />

    <select
      name="role"
      value={form.role}
      onChange={handleChange}
      className="w-full p-3 rounded-lg border border-slate-300 dark:border-slate-700 bg-light dark:bg-slate-800 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
    >
      <option value="admin">Admin</option>
      <option value="superadmin">Super Admin</option>
      <option value="loading_manager">Loading Manager</option>
    </select>

    <div className="text-right">
      <button
        type="submit"
        className="bg-primary dark:bg-primary-light text-white px-5 py-2 rounded-lg hover:bg-primary-dark dark:hover:bg-primary"
      >
        Register
      </button>
    </div>
  </form>
);

}